"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultCellSize = exports.default = void 0;

var _preact = require("preact");

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _Sorting = _interopRequireDefault(require("../../preact-components/table/Sorting"));

var _classnames = _interopRequireDefault(require("classnames"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var defaultCellSize = 'm';
exports.defaultCellSize = defaultCellSize;

var EmptyTable = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(EmptyTable, _Component);

  var _super = _createSuper(EmptyTable);

  function EmptyTable() {
    (0, _classCallCheck2.default)(this, EmptyTable);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(EmptyTable, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          model = _this$props.model,
          children = _this$props.children,
          sort = _this$props.sort,
          narrow = _this$props.narrow,
          _this$props$classes = _this$props.classes,
          classes = _this$props$classes === void 0 ? [] : _this$props$classes,
          _this$props$style = _this$props.style,
          style = _this$props$style === void 0 ? {} : _this$props$style,
          _this$props$staticWid = _this$props.staticWidth,
          staticWidth = _this$props$staticWid === void 0 ? false : _this$props$staticWid,
          actionElements = _this$props.actionElements;
      var useObjectModel = model === null || model === void 0 ? void 0 : model[0].hasOwnProperty('header');
      return (0, _preact.h)("div", {
        className: "control-table"
      }, actionElements && (0, _preact.h)("div", {
        className: "action-bar-wrapper"
      }, (0, _preact.h)("div", {
        className: "action-bar"
      }, actionElements)), (0, _preact.h)("div", {
        className: "table-wrapper"
      }, (0, _preact.h)("table", {
        className: _classnames.default.apply(void 0, [{
          narrow: narrow
        }].concat((0, _toConsumableArray2.default)(classes))),
        style: style
      }, (0, _preact.h)("thead", null, (0, _preact.h)("tr", null, model && Object.keys(model).map(function (key) {
        if (model[key].isHidden) {
          return null;
        }

        return (0, _preact.h)("th", {
          key: key,
          className: "".concat(model[key].size || defaultCellSize)
        }, !model[key].hasOwnProperty('sorting') && (0, _preact.h)("div", {
          className: "table-header-cell-".concat(model[key].accessor)
        }, useObjectModel ? model[key].header : String(model[key])), model[key].hasOwnProperty('sorting') && (0, _preact.h)("div", {
          className: "table-header-cell-".concat(model[key].accessor, " sortable")
        }, useObjectModel ? model[key].header : String(model[key]), (0, _preact.h)(_Sorting.default, {
          direction: sort === null || sort === void 0 ? void 0 : sort.direction,
          isEnabled: (sort === null || sort === void 0 ? void 0 : sort.order) === model[key].sorting
        })));
      })))), children));
    }
  }]);
  return EmptyTable;
}(_preact.Component);

var _default = EmptyTable;
exports.default = _default;